import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Lock, CreditCard, BookOpen, Zap } from 'lucide-react';
import { CTAButton, CHECKOUT_URL } from './Shared';
const heroImage = {
  src: 'https://cdn.magicpatterns.com/uploads/3kcM334Qq72QcY9NcPxkcq/Portada_Mokup_NUEVO_CHIKUNG.png',
  alt: 'Mega Pack Chi Kung — 3 tomos y 6 bonos impresos'
};
const trustItems = [{
  icon: Shield,
  label: 'Garantía 7 días'
}, {
  icon: Lock,
  label: 'Pago seguro'
}, {
  icon: CreditCard,
  label: 'Mercado Pago'
}, {
  icon: BookOpen,
  label: '100% PDF'
}, {
  icon: Zap,
  label: 'Acceso en 5 min'
}];
export const Hero = () => {
  return <header className="relative overflow-hidden bg-transparent pt-2 pb-8 md:pt-14 md:pb-16" data-id="element-136" data-mp="sa02lrfuzorh">
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 overflow-hidden" data-id="element-137" data-mp="nbez9j5b8oyt">
        <div className="absolute top-14 right-[3%] select-none font-hanzi text-[92px] font-light leading-none text-brand-goldDark/[0.09] md:text-[168px]" data-id="element-138" data-mp="3d2bkbqsid1w2">
          氣
        </div>
        <div className="absolute bottom-6 left-[3%] select-none font-hanzi text-[76px] font-light leading-none text-brand-goldDark/[0.08] md:text-[132px]" data-id="element-139" data-mp="3j898df6ywfql">
          和
        </div>
        <div className="absolute top-[32%] left-[6%] hidden h-64 w-64 rounded-full border border-brand-goldDark/10 md:block" data-id="element-140" data-mp="39al8kaui8i1k" />
        <div className="absolute bottom-[6%] right-[6%] hidden h-48 w-48 rounded-full border border-brand-greenDark/10 md:block" data-id="element-141" data-mp="3e8eh3aja5o50" />
      </div>

      <div className="relative z-10 mx-auto max-w-6xl px-4 text-center sm:px-6 lg:px-8" data-id="element-142" data-mp="30fybq32wpe0x">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-143" data-mp="35aud3tu19dqp">
          <div className="mb-2 flex flex-col items-center gap-1.5 md:mb-8 md:gap-3" data-id="element-144" data-mp="2vgtwovtawm2o">
            <span className="font-display text-[10px] font-semibold uppercase tracking-[0.42em] text-brand-goldDark md:text-xs" data-id="element-145" data-mp="2hjyn92950sm3">
              Lumen Akasha
            </span>
            <span aria-hidden="true" className="ink-rule w-16 md:w-24" data-id="element-146" data-mp="s2tf1pz30hru" />
          </div>

          <h1 className="mx-auto max-w-[19ch] font-serif text-[40px] font-semibold leading-[0.98] tracking-[-0.015em] text-brand-burgundy sm:max-w-4xl sm:text-6xl sm:leading-[1.04] md:text-7xl lg:text-[84px]" style={{
          width: "334px",
          height: "68px"
        }} data-id="element-147" data-mp="naa0aponrglg">
            Sesiones más{' '}
            <span className="relative inline-block" data-id="element-148" data-mp="1b1fez1iv42u6">
              <span aria-hidden="true" className="absolute inset-x-[-6px] bottom-[0.1em] h-[0.34em] bg-brand-goldLight/55" data-id="element-149" data-mp="1ayt8l57pjtdj" />
              <span className="relative" data-id="element-150" data-mp="112pzffefuuh3">efectivas</span>
            </span>{' '}
            y sin improvisar.
          </h1>

          

          <p className="mx-auto mt-2 max-w-[30ch] font-serif text-[19px] italic leading-[1.25] text-brand-textLight/85 sm:max-w-2xl md:mt-6 md:text-2xl md:leading-relaxed lg:text-[27px]" data-id="element-151" data-mp="x0324yz00hci">
            El conocimiento ya lo tenés. El sistema para aplicarlo, ahora
            también.
          </p>

          <div className="flex flex-col" data-id="element-152" data-mp="1xaceczu3ndrn">
            <div className="order-1 mx-auto mt-4 w-full max-w-[560px] md:mt-12 md:max-w-3xl lg:max-w-4xl relative" data-id="element-153" data-mp="1x7871tlc81wr">
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[85%] h-[85%] rounded-full bg-brand-gold/15 blur-[60px] md:blur-[100px] -z-10" data-id="element-154" data-mp="269zjnwpy93pz" />
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[70%] h-[70%] rounded-full border border-brand-goldDark/20 -z-10" data-id="element-155" data-mp="2b2smug5rs3zy" />
              <motion.img src={heroImage.src} alt={heroImage.alt} initial={{
              opacity: 0,
              scale: 0.97
            }} animate={{
              opacity: 1,
              scale: 1
            }} transition={{
              duration: 0.55,
              ease: [0.23, 1, 0.32, 1]
            }} className="mx-auto h-auto max-h-[46vh] w-full object-contain mix-blend-multiply md:max-h-none relative z-10 drop-shadow-[0_0_8px_rgba(168,135,78,0.8)] drop-shadow-[0_0_2px_rgba(124,96,51,0.9)]" draggable={false} fetchpriority="high" decoding="async" data-id="element-156" data-mp="2kxucre7vda3l" />
            </div>

            <div className="order-2 mt-1 flex flex-col items-center gap-3 md:order-3 md:mt-10 md:gap-6" data-id="element-157" data-mp="99xo7vrk6dod">
              <CTAButton variant="purple" href={CHECKOUT_URL} className="px-8 py-3.5 text-[13px] md:px-12 md:py-5 md:text-base" data-id="element-158" data-mp="3hphcegddh5wk">
                Quiero mi Mega Pack
              </CTAButton>

              <ul className="flex flex-wrap items-center justify-center gap-x-5 gap-y-1.5 font-sans text-[12.5px] text-brand-muted md:gap-x-6 md:text-sm" data-id="element-159" data-mp="3rglrdg31sqre">
                {trustItems.map(({
                icon: Icon,
                label
              }) => <li key={label} className="flex items-center gap-1.5" data-id="element-160" data-mp="2yxya6br69vvl">
                    <Icon className="h-3.5 w-3.5 shrink-0 text-brand-goldDark md:h-4 md:w-4" data-id="element-161" data-mp="2tzmw1otugz7k" />
                    {label}
                  </li>)}
              </ul>
            </div>

            <div className="order-3 mx-auto mt-7 max-w-3xl md:order-2 md:mt-10" data-id="element-162" data-mp="1e9ngb92atd36">
              <h2 className="font-display text-[17px] font-bold uppercase tracking-[0.16em] text-brand-burgundy md:text-3xl" data-id="element-163" data-mp="zkr9tgfw484o">
                Mega Pack Chi Kung
              </h2>
              <p className="mx-auto mt-3 max-w-2xl font-serif text-[16px] leading-relaxed text-brand-textLight/85 md:text-xl" data-id="element-164" data-mp="14h7ws7bcsgg6">
                Sistema clínico integral para terapeutas: sesiones
                pre-diseñadas, blindaje del terapeuta, planificación anual y
                herramientas de consultorio listas para usar.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </header>;
};